// pipe: 4B.8 (Task 11) — driver "My Pickups" list container. Wires the
// Bearer-authed DriverErpService (via the driver context hook) to the pure
// PickupsView. All the fetch/state/effect + navigation plumbing lives HERE,
// never in pickups-view.tsx (the Vitest-tested seam).
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import type { DriverPickup } from '../services/driver-erp';
import { useDriverErp } from '../services/driver-erp-provider';
import { PickupsView } from './pickups-view';

export function Pickups() {
  const erp = useDriverErp();
  const navigate = useNavigate();
  const [rows, setRows] = useState<DriverPickup[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    erp
      .listPickups()
      .then(r => {
        if (!cancelled) {
          setRows(r);
        }
      })
      .catch((e: unknown) => {
        if (!cancelled) {
          setError(e instanceof Error ? e.message : String(e));
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [erp]);

  // The pickup-complete flow lives at `/pickups/:id` (added in Task 12). Until
  // then the route is harmless — the pure-view test covers the affordance.
  const onComplete = (id: string) => navigate(`/pickups/${id}`);
  // P3.4: the trip-log form (Monday Driver Log §6).
  const onTripLog = (id: string) => navigate(`/pickups/${id}/trip`);

  return (
    <PickupsView
      rows={rows}
      loading={loading}
      error={error}
      onComplete={onComplete}
      onTripLog={onTripLog}
    />
  );
}
